var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "50px",
    viewBox: "0 0 100 50",
    enableBackground: "new 0 0 100 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 68.066,
    y1: 17.305,
    x2: 31.192,
    y2: 17.305
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.066,17.305h5.938 c0.271,0,0.495-0.197,0.495-0.439v-0.88v-0.881v-1.319c0-0.243-0.224-0.44-0.495-0.44h-49c-0.273,0-0.495,0.197-0.495,0.44v1.319 v0.44v1.321c0,0.242,0.222,0.439,0.495,0.439h6.188"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.192,
    y1: 22.255,
    x2: 68.066,
    y2: 22.255
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 68.066,
    y1: 26.215,
    x2: 31.192,
    y2: 26.215
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.192,22.255h-6.188 c-0.273,0-0.495,0.197-0.495,0.44v1.32v0.438v1.321c0,0.242,0.222,0.439,0.495,0.439h6.188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.066,26.215h5.938 c0.271,0,0.495-0.197,0.495-0.439v-0.881v-0.879v-1.32c0-0.243-0.224-0.44-0.495-0.44h-5.938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.192,31.164H21.85 c-0.307,0-0.558,0.222-0.558,0.494v1.486v0.491v1.488c0,0.271,0.251,0.492,0.558,0.492h3.402"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.192,
    y1: 31.164,
    x2: 68.066,
    y2: 31.164
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.066,31.164h9.093 c0.306,0,0.558,0.222,0.558,0.494v1.486v0.987v0.992c0,0.271-0.252,0.492-0.558,0.492h-3.402"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 73.757,
    y1: 35.617,
    x2: 25.252,
    y2: 35.617
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.192,
    y1: 31.164,
    x2: 31.192,
    y2: 26.215
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.192,
    y1: 17.305,
    x2: 31.192,
    y2: 22.255
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.192,17.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.192,31.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.192,26.215"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 68.066,
    y1: 17.305,
    x2: 68.066,
    y2: 22.255
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 68.066,
    y1: 31.164,
    x2: 68.066,
    y2: 26.215
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.066,26.215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.066,22.255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.066,17.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.066,31.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M25.252,45.021"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.252,
    y1: 35.617,
    x2: 25.252,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M25.252,35.617"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 73.757,
    y1: 35.617,
    x2: 73.757,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M73.757,45.021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M73.757,35.617"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 99,
    y1: 45.021,
    x2: 90.09,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.09,
    y1: 45.021,
    x2: 73.757,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.252,
    y1: 45.021,
    x2: 9.414,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.252,
    y1: 45.021,
    x2: 73.757,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 45.021,
    x2: 1,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 41.311,
    x2: 9.414,
    y2: 40.671
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 41.311,
    x2: 9.414,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.414,45.021"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 32.648,
    x2: 9.414,
    y2: 32.258
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.414,22.75"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 32.648,
    x2: 9.414,
    y2: 40.671
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 22.75,
    x2: 9.414,
    y2: 32.258
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.09,
    y1: 40.32,
    x2: 90.09,
    y2: 40.157
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M90.09,45.021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M90.09,32.139"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.09,
    y1: 40.32,
    x2: 90.09,
    y2: 45.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.09,
    y1: 32.139,
    x2: 90.09,
    y2: 40.157
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 5.846,
    y1: 28.984,
    x2: 9.414,
    y2: 32.258
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.619,32.443"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 32.258,
    x2: 9.619,
    y2: 32.443
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.846,28.984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.161,28.902"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.161,
    y1: 28.902,
    x2: 9.619,
    y2: 32.443
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 32.648,
    x2: 9.619,
    y2: 32.443
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.414,32.648"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.804,37.359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.748,40.977"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 5.804,
    y1: 37.359,
    x2: 9.414,
    y2: 40.671
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 40.671,
    x2: 9.748,
    y2: 40.977
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.322,37.4"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.322,
    y1: 37.4,
    x2: 9.748,
    y2: 40.977
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.414,41.311"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.414,
    y1: 41.311,
    x2: 9.748,
    y2: 40.977
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M85.361,35.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M90.175,40.236"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.09,
    y1: 40.157,
    x2: 90.175,
    y2: 40.236
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 85.361,
    y1: 35.753,
    x2: 90.09,
    y2: 40.157
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 94.57,
    y1: 35.84,
    x2: 90.175,
    y2: 40.236
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M90.09,40.32"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 90.09,
    y1: 40.32,
    x2: 90.175,
    y2: 40.236
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M94.57,35.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.414,22.75 c2.969,0,2.475-2.723,2.475-2.723c0-1.484-2.475-3.711-2.475-3.711s-2.475,2.227-2.475,3.711C6.939,20.027,6.444,22.75,9.414,22.75 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.161,28.902 c0.046,0.049,0.084,0.099,0.135,0.148c2.118,2.082,3.673-0.207,3.673-0.207c1.041-1.059,0.836-4.383,0.836-4.383 s-3.326-0.145-4.367,0.914C13.439,25.375,11.298,26.896,13.161,28.902"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.846,28.984 c2.003-2.047-0.203-3.609-0.203-3.609c-1.041-1.059-4.367-0.914-4.367-0.914s-0.205,3.324,0.837,4.383c0,0,1.555,2.289,3.672,0.207 C5.809,29.029,5.824,29.009,5.846,28.984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.322,37.4 c2.105,2.039,3.647-0.229,3.647-0.229c1.041-1.057,0.837-4.381,0.837-4.381s-3.327-0.146-4.368,0.912c0,0-2.261,1.596-0.143,3.678 C13.305,37.389,13.314,37.395,13.322,37.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.804,37.359 c2.085-2.07-0.16-3.656-0.16-3.656c-1.041-1.059-4.367-0.912-4.367-0.912s-0.205,3.324,0.837,4.381c0,0,1.555,2.292,3.672,0.209 C5.793,37.373,5.798,37.368,5.804,37.359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M90.09,32.139 c2.689-0.147,2.236-2.707,2.236-2.707c0-1.484-2.477-3.711-2.477-3.711s-2.476,2.227-2.476,3.711c0,0-0.495,2.723,2.476,2.723 C89.938,32.154,90.01,32.145,90.09,32.139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M85.361,35.753 c0-0.003,0.004-0.003,0.006-0.005c2.117-2.084-0.145-3.678-0.145-3.678c-1.039-1.06-4.363-0.913-4.363-0.913 s-0.207,3.325,0.834,4.381C81.693,35.538,83.246,37.822,85.361,35.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M94.57,35.84 c2.064,1.903,3.568-0.302,3.568-0.302c1.041-1.056,0.838-4.381,0.838-4.381s-3.326-0.146-4.367,0.913c0,0-2.262,1.594-0.143,3.678 C94.503,35.781,94.538,35.807,94.57,35.84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.f08aa607e27c7b82fdb7dda22c2440d8.svg";
export { ForwardRef as ReactComponent };